module.exports = __webpack_public_path__ + "img/index_new_bg1.e483871a.png";